import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { OnlyAlphaNumericValidator } from "src/app/directives/only-alpha-numeric-validator";
import { AccountModel } from "src/app/models/onboarding.model";
import { OnboardingService } from "src/app/services/onboarding.service";
import { HeaderService } from "../../header/header.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../snackbar/snackbar.component';

@Component({
  selector: "app-amazon-new-connection",
  templateUrl: "./amazon-new-connection.component.html",
  styleUrls: [
    "../new-connection.scss",
    "./amazon-new-connection.component.scss",
  ],
})
export class AmazonNewConnectionComponent implements OnInit,OnDestroy {
  public addAccountForm: FormGroup;
  amazonMarkets;
  spinLoader = false;
  isdisable: boolean = false;
  @Output() saved: EventEmitter<boolean> = new EventEmitter();
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  private destroy$ = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    private onboardingService: OnboardingService,
    private snackBar: MatSnackBar,
    private headerService:HeaderService
  ) {}

  ngOnInit(): void {
    this.getAmazonAccounts();

    this.addAccountForm = this.fb.group({
      name: ["", [Validators.required, OnlyAlphaNumericValidator]],
      marketPlace: ["", [Validators.required]],
      seller: ["", [Validators.required]],
      token: ["", [Validators.required]],
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  openAmazonMWSPage() {
    this.onboardingService.AmazonLink().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      window.open(res, "_blank");
    });
  }

  saveNewMarketplace() {
    this.spinLoader = true;
    this.addAccountForm.patchValue({
      name: this.addAccountForm.get("name").value.trim(),
    });
    this.verifyCredentials();
  }

  getAmazonAccounts() {
    this.onboardingService.AmazonMarkets().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.amazonMarkets = res;
    });
  }

  verifyCredentials() {
    const amazonCredentials = this.addAccountForm.value;
    const seller = {
      seller: this.addAccountForm.value.seller,
      marketPlace: this.addAccountForm.value.marketPlace,
    };
    this.onboardingService.SellerExists(seller).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Seller ID already exist!',
                  action: 'Dismiss',
                  type: 'info',
                },
              }
          );
          this.addAccountForm.controls["seller"].setValue("");
          this.spinLoader = false;
        } else {
            this.onboardingService
            .verifyCredential(amazonCredentials)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (res: boolean[]) => {
                if (res.every((item) => item === true)) {
                  this.onboardingService
                    .InsertAccount(amazonCredentials as AccountModel).pipe(takeUntil(this.destroy$))
                    .subscribe(() => {
                      this.snackBar.openFromComponent(SnackbarComponent,
                          {
                            duration: 3000,
                            horizontalPosition: 'center',
                            data: {
                              title: 'Your Amazon account was linked successfully',
                              action: 'Dismiss',
                                type: 'success',
                            },
                          }
                      );
                      this.saved.emit(true);
                      this.headerService.RefreshDropdown$.next(true);
                    });
                } else {
                  this.snackBar.openFromComponent(SnackbarComponent,
                      {
                        duration: 3000,
                        horizontalPosition: 'center',
                        data: {
                          title: 'Please check your credentials',
                          action: 'Dismiss',
                            type: 'error',
                        },
                      }
                  );
                }
                this.spinLoader = false;
              },
             error: (err) => {
                  this.snackBar.openFromComponent(SnackbarComponent,
                    {
                      duration: 3000,
                      horizontalPosition: 'center',
                      data: {
                        title: 'Please check your credentials',
                        action: 'Dismiss',
                          type: 'error',
                      },
                    }
                );
                this.spinLoader = false;
              }
           });
        }
      },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
              type: 'error',
          },
        }
    );
    this.spinLoader = false;
     }
   });
  }

  cancel() {
    this.close.emit();
  }

  duplicateNameValidator(value) {
    if (!this.addAccountForm.get("name").hasError("invalidError")) {
      if (!this.isdisable) {
        this.onboardingService
          .DuplicateAccountName(value.target.value).pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            if (res) this.isdisable = true;
            else this.isdisable = false;
          });
      }
    }
  }
}
